import React from 'react';
import moment from 'moment';
import styles from './active-filters.module.scss';

const getActiveItems = (filters, query) => {
  if (!filters || typeof filters !== 'object') return [];
  const items = [];

  Object.entries(filters).forEach(([fieldKey, config]) => {
    const {
      type,
      label,
      values = [],
      alias,
      field,
      defaultValue,
      neutralValue,
    } = config;
    const key = alias || field;

    if (type === 'select') {
      const value = query[key];
      const hasValue = value !== undefined && value !== null && value !== '';
      const hasNeutral = neutralValue !== undefined || defaultValue !== undefined;
      const isNeutral = hasNeutral && String(value) === String(
        neutralValue !== undefined ? neutralValue : defaultValue
      );

      if (hasValue && !isNeutral) {
        const option = values.find(v => String(v.id) === String(value));
        items.push({
          key: fieldKey,
          queryKey: key,
          label,
          display: option ? option.value : value,
          clear: () => ({ [key]: '' }),
        });
      }
    } else if (type === 'range') {
      const min = query[`${key}Min`];
      const max = query[`${key}Max`];
      const hasMin = min !== undefined && min !== null && min !== '';
      const hasMax = max !== undefined && max !== null && max !== '';
      if (hasMin || hasMax) {
        const minVal = hasMin ? Number(min) : '';
        const maxVal = hasMax ? Number(max) : '';
        const display = [minVal, maxVal].filter(v => v !== '').join(' – ');
        items.push({
          key: fieldKey,
          queryKey: key,
          label,
          display,
          clear: () => ({ [`${key}Min`]: '', [`${key}Max`]: '' }),
        });
      }
    } else if (type === 'date-range') {
      const dateMin = query.dateMin;
      const dateMax = query.dateMax;
      const hasMin = dateMin !== undefined && dateMin !== null && dateMin !== '';
      const hasMax = dateMax !== undefined && dateMax !== null && dateMax !== '';
      if (hasMin || hasMax) {
        const start = hasMin ? moment(Number(dateMin)).format('DD.MM.YYYY') : '';
        const end = hasMax ? moment(Number(dateMax)).format('DD.MM.YYYY') : '';
        const display = [start, end].filter(Boolean).join(' – ');
        items.push({
          key: fieldKey,
          queryKey: 'date',
          label,
          display,
          clear: () => ({ dateMin: '', dateMax: '' }),
        });
      }
    }
  });

  return items;
};

export const getActiveFiltersCount = (filters, query) => getActiveItems(filters, query).length;

const ActiveFilters = ({ filters, query, setQuery, inPopup }) => {
  const activeItems = getActiveItems(filters, query);

  if (activeItems.length === 0) return null;

  const onClearOne = (item) => {
    setQuery(item.clear());
  };

  const onClearAll = () => {
    const clearPayload = activeItems.reduce((acc, item) => ({ ...acc, ...item.clear() }), {});
    setQuery(clearPayload);
  };

  return (
    <div className={inPopup ? styles.wrapperInPopup : styles.wrapper}>
      <div className={styles.header}>
        <span className={styles.title}>Текущий фильтр</span>
        <span className={styles.badge}>{activeItems.length}</span>
        <button
          type="button"
          className={styles.clearAll}
          onClick={onClearAll}
        >
          Сбросить все
        </button>
      </div>
      <div className={styles.chips}>
        {activeItems.map(item => (
          <span key={item.key} className={styles.chip}>
            <span className={styles.chipLabel}>{item.label}:</span>
            <span className={styles.chipValue}>{item.display}</span>
            <span className={styles.chipBadge} aria-hidden />
            <button
              type="button"
              className={styles.chipClear}
              onClick={() => onClearOne(item)}
              aria-label={`Сбросить ${item.label}`}
            >
              ×
            </button>
          </span>
        ))}
      </div>
    </div>
  );
};

export default ActiveFilters;
